import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { buildPersonalInfoPayload } from "../../../../utils/buildUserPayload";
import { editUser } from "../../../../utils/updateUser";
import { useSnackbar } from "../../../../component/SnackbarContext";
import {
  setPersonalDetails,
  setLoginDetails,
} from "../../../../Redux/Slices/counterSlice";
import DetailsForm from "./detailsForm";

export default function PersonalDetails() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { authDetails } = useSelector((state) => state.counter);

  let showSnackbar = useSnackbar();

  useEffect(() => {
    if (!authDetails?.otpVerified) {
      navigate("/auth/account");
    }
  }, []);
  const handleContinue = async (personalDetails) => {
    if (authDetails?.userType === "business user") {
      setPersonalInfo(personalDetails);
      navigate("/auth/business-details");
    } else if (authDetails?.userType === "delivery user") {
      setPersonalInfo(personalDetails);
      navigate("/auth/delivery-details");
    } else if (authDetails?.userType === "normal user") {
      try {
        await editUser(
          buildPersonalInfoPayload(personalDetails),
          authDetails?.userId,
          showSnackbar
        );
        dispatch(setLoginDetails(authDetails));
        navigate("/customer-home");
      } catch (error) {
        showSnackbar("Edit user failed:", "error");
      }
    }
  };

  const setPersonalInfo = (personalDetails) => {
    dispatch(setPersonalDetails(personalDetails));
  };

  return (
    <DetailsForm
      email_id={authDetails?.email}
      phone_number={authDetails?.phone_number}
      onContinue={handleContinue}
      userType={authDetails?.userType}
    />
  );
}
